import React, { CSSProperties } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './FallbackImage.module.scss';

export const FallbackImage: React.FC<{ fallbackImageStyles: CSSProperties }> =
	React.memo(({ fallbackImageStyles }) => {
		return (
			<StaticImage
				src="../../../../images/backgrounds/home-frame-blured.webp"
				alt="Fallback image"
				style={fallbackImageStyles}
				className={styles.fluid}
				objectFit="cover"
				objectPosition="top"
				placeholder="blurred"
			/>
		);
	});
